// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__noInfo___ji1Rv {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  font-weight: 300;
  font-style: italic;
}

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC {
    display: grid;
    grid-template-columns: 3fr 1fr 2fr 1fr;
    margin-bottom: 12px;
  }

@media only screen and (max-width: 1268px) {

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC {
      grid-template-columns: 2fr 1fr 2fr 1fr;
  }
    }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC .styles__requestInfoItem___PFZ8N {
      font-size: 11px;
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
    }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC .styles__requestInfoItem___PFZ8N:nth-child(1) {
        margin-right: 4px !important;
      }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC .styles__requestInfoItem___PFZ8N:nth-child(2) {
        text-align: right;
        margin-right: 4px !important;
      }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC .styles__requestInfoItem___PFZ8N:nth-child(3) {
        text-align: right;
        margin-right: 4px !important;
      }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC .styles__requestInfoItem___PFZ8N:nth-child(4) {
        text-align: right;
        margin-right: 0px !important;
      }

.styles__requestInfo___OzRf6 .styles__requstInfoList___lbmcC:nth-last-child(1) .styles__requestInfoItem___PFZ8N:nth-child(2) {
          border-bottom: 1px solid rgba(128, 128, 128, 0.705);
        }
.styles__requestInfoContainer___SbGWd {
  display: flex;
  flex-direction: column;
}

.styles__infoTotal___Arv_N {
  width: calc(99.9% * 60/100 - (30px - 30px * 60/100));
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  font-size: 11px;
  font-weight: 700;
  color: back;
  opacity: 0.75;
}

.styles__infoTotal___Arv_N:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__infoTotal___Arv_N:last-child {
  margin-right: 0;
}

.styles__infoTotal___Arv_N:nth-child(100n) {
  margin-right: 0;
  float: right;
}

.styles__infoTotal___Arv_N:nth-child(100n + 1) {
  clear: both;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/RequestInfo/styles.css"],"names":[],"mappings":"AAGA;EACE,mDAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAGE;IACE,aAAa;IACb,sCAAsC;IAItC,mBAAmB;EA4BrB;;AA/BE;;AAHF;MAII,sCAAsC;EA8B1C;IA7BE;;AAEA;MACE,eAAe;MACf,mDAAiB;IAiBnB;;AAfE;QACE,4BAA4B;MAC9B;;AACA;QACE,iBAAiB;QACjB,4BAA4B;MAC9B;;AACA;QACE,iBAAiB;QACjB,4BAA4B;MAC9B;;AACA;QACE,iBAAiB;QACjB,4BAA4B;MAC9B;;AAIE;UACE,mDAAmD;QACrD;AAKR;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oDAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AATA;EACE,WAAmB;EAAnB,kBAAmB;EAAnB,WAAmB;AAQrB;;AATA;EACE,eAAmB;AAQrB;;AATA;EACE,eAAmB;EAAnB,YAAmB;AAQrB;;AATA;EACE,WAAmB;AAQrB","sourcesContent":["@value colors: 'styles/colors.css';\n@value gtGrayDark,textDark,gtGray from colors;\n\n.noInfo {\n  color: gtGrayDark;\n  font-weight: 300;\n  font-style: italic;\n}\n\n.requestInfo {\n  .requstInfoList {\n    display: grid;\n    grid-template-columns: 3fr 1fr 2fr 1fr;\n    @media only screen and (max-width: 1268px) {\n      grid-template-columns: 2fr 1fr 2fr 1fr;\n    }\n    margin-bottom: 12px;\n    .requestInfoItem {\n      font-size: 11px;\n      color: gtGrayDark;\n\n      &:nth-child(1) {\n        margin-right: 4px !important;\n      }\n      &:nth-child(2) {\n        text-align: right;\n        margin-right: 4px !important;\n      }\n      &:nth-child(3) {\n        text-align: right;\n        margin-right: 4px !important;\n      }\n      &:nth-child(4) {\n        text-align: right;\n        margin-right: 0px !important;\n      }\n    }\n    &:nth-last-child(1) {\n      .requestInfoItem {\n        &:nth-child(2) {\n          border-bottom: 1px solid rgba(128, 128, 128, 0.705);\n        }\n      }\n    }\n  }\n}\n.requestInfoContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.infoTotal {\n  lost-column: 60/100;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  font-size: 11px;\n  font-weight: 700;\n  color: back;\n  opacity: 0.75;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'styles/colors.css'`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"textDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textDark"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"noInfo": `styles__noInfo___ji1Rv`,
	"requestInfo": `styles__requestInfo___OzRf6`,
	"requstInfoList": `styles__requstInfoList___lbmcC`,
	"requestInfoItem": `styles__requestInfoItem___PFZ8N`,
	"requestInfoContainer": `styles__requestInfoContainer___SbGWd`,
	"infoTotal": `styles__infoTotal___Arv_N`
};
export default ___CSS_LOADER_EXPORT___;
